import _ from 'lodash';
import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';

export const FETCH_SCHEDULES_DATES = 'FETCH_SCHEDULES_DATES';
export const MY_AGENDA_LIST = 'MY_AGENDA_LIST';
export const CURRENT_DATE_AGENDA = 'CURRENT_DATE_AGENDA';
export const FETCH_MEETINGS = 'FETCH_MEETINGS';

export const fetchScheduleDates = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})AND(isactive=1)`);
  let orderby = 'scheduledate%20ASC';
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduledates?include_count=true&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_SCHEDULES_DATES,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { data: data.resource, count: data.meta.count }
        });
      },
      error => {
        // callback({ success: 0, error: error });
      }
    );
  };
};

export function clearScheduleDates(obj) {
  return dispatch => {
    dispatch({
      type: FETCH_SCHEDULES_DATES,
      payload: obj
    });
  };
}

export const fetchAgenda = (session, callback) => {
  let bkmrkFilter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=schedule))`
  );
  let bkmrkUrl = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?filter=${bkmrkFilter}`;

  let rsvpFilter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid}))`
  );
  let rsvpUrl = `${INSTANCE_URL}/api/v2/eventify/_table/session_rsvp?filter=${rsvpFilter}`;

  return dispatch => {
    getRequest(
      bkmrkUrl,
      session,
      dispatch,
      bookmarkRes => {
        getRequest(
          rsvpUrl,
          session,
          dispatch,
          rsvpRes => {
            let concattedResource = _.concat(
              bookmarkRes?.resource,
              rsvpRes.resource
            );

            if (concattedResource.length > 0) {
              let idStr = [];
              _.map(concattedResource, (item, index) => {
                let idToAdd = item.typeid || item.sessionid; // Choose appropriate id
                idStr.push(idToAdd);
              });
              idStr = _.uniq(idStr);
              idStr = idStr.join(',');

              var agendaFilter = encodeURI(
                `(eventid=${session.eventid})AND(sessionid IN (${idStr}))`
              );
              var related = 'speaker_by_sessionspeakers,speaker_by_speakerid';
              var orderby = 'starttime%20ASC';
              let agendaFetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/session?include_count=true&related=${related}&filter=(${agendaFilter})&order=${orderby}`;
              getRequest(
                agendaFetchUrl,
                session,
                dispatch,
                data => {
                  // console.log('data: ', data);
                  dispatch({
                    type: MY_AGENDA_LIST,
                    payload: { resource: data.resource }
                  });
                  callback({ success: 1, resource: data.resource });
                },
                error => {}
              );
            } else {
              dispatch({
                type: MY_AGENDA_LIST,
                payload: { resource: concattedResource }
              });
              callback({ success: 1, resource: concattedResource });
            }
          },
          rsvpError => {}
        );
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export function clearAgenda(obj) {
  return dispatch => {
    dispatch({
      type: MY_AGENDA_LIST,
      payload: obj
    });
  };
}

export function currentDateAgenda(value) {
  return dispatch => {
    dispatch({
      type: CURRENT_DATE_AGENDA,
      payload: { data: value, count: value.length }
    });
  };
}

export const fetchMeetings = (session, callback) => {
  var senderFilter = encodeURI(
    `((eventid=${session.eventid})AND(senderid=${session.userid})AND(chattype=meeting)AND(meetingstatus=accepted))`
  );
  var senderUrl = `${INSTANCE_URL}/api/v2/eventify/_table/chat?related=chatthread_by_chatthreadid,appuser_by_receiverid&filter=(${senderFilter})&include_count=true`;

  var receiverFilter = encodeURI(
    `((eventid=${session.eventid})AND(receiverid=${session.userid})AND(chattype=meeting)AND(meetingstatus=accepted))`
  );
  var receiverUrl = `${INSTANCE_URL}/api/v2/eventify/_table/chat?related=chatthread_by_chatthreadid,appuser_by_senderid&filter=(${receiverFilter})&include_count=true`;

  var meetings = [];

  return dispatch => {
    getRequest(
      senderUrl,
      session,
      dispatch,
      senderRes => {
        if (senderRes.meta.count > 0) {
          meetings = senderRes.resource;
          getRequest(
            receiverUrl,
            session,
            dispatch,
            receiverRes => {
              if (receiverRes.meta.count > 0) {
                meetings = _.concat(meetings, receiverRes.resource);
              }
              meetings = _.orderBy(meetings, 'scheduledon', 'asc');
              dispatch({
                type: FETCH_MEETINGS,
                payload: {
                  data: meetings,
                  count: senderRes.meta.count + receiverRes.meta.count
                }
              });
              callback({
                success: true,
                data: meetings,
                count: senderRes.meta.count + receiverRes.meta.count
              });
            },
            receiverError => {
              callback({ success: false, message: receiverError });
            }
          );
        } else {
          getRequest(
            receiverUrl,
            session,
            dispatch,
            receiverRes => {
              meetings =
                receiverRes.meta.count > 0
                  ? _.orderBy(receiverRes.resource, 'scheduledon', 'asc')
                  : [];
              // meetings = receiverRes.resource;
              dispatch({
                type: FETCH_MEETINGS,
                payload: {
                  data: meetings,
                  count: receiverRes.meta.count
                }
              });
              callback({
                success: true,
                data: meetings,
                count: receiverRes.meta.count
              });
            },
            receiverError => {
              callback({ success: false, message: receiverError });
            }
          );
        }
      },
      senderError => {
        callback({ success: false, message: senderError });
      }
    );
  };
};

export const updateMeeting = (session, type, value, callback) => {
  var url = `${INSTANCE_URL}/api/v2/meetings`;

  return dispatch => {
    postRequest(
      url,
      value,
      session,
      dispatch,
      response => {
        dispatch(clearMeeting());
        dispatch(fetchMeetings(session, res => {}));
        callback({ success: true });
      },
      error => {
        callback({ success: false, messahe: error });
      }
    );
  };
};

export const clearMeeting = () => {
  return dispatch => {
    dispatch({ type: FETCH_MEETINGS, payload: { data: [], count: 0 } });
  };
};
